import React from 'react';
import {CardBody, Form, FormGroup, Input, Label, Modal, Row, Col} from "reactstrap";
import DropImage from "../../components/DropImage";
import Select from "react-select";

const text_amount = (amount) => {
  return `$ ${(amount * 1).toFixed(2)}`
}

const percent_shortcuts = [10, 15, 20, 30];

const render_amount_tab = (onChangeInput, discount) => {
  return (
    <FormGroup>
      <Label htmlFor="discount_amount">Monto del descuento</Label>
      <Input autoComplete="off" type="number" className="form-control" id="discount_amount" defaultValue={discount} onChange={ e => {onChangeInput(Number(e.target.value), 'discount')} }/>
    </FormGroup>
  );
}

const render_percent_tab = (onChangeInput, discount_percent, total) => {
  return (
    <FormGroup>
      <Label htmlFor="discount_percent">Porcentaje de descuento</Label>
      <Input autoComplete="off" type="number" min="0" max="100" className="form-control" id="discount_percent" value={discount_percent} onChange={ e => {onChangeInput(Number(e.target.value), 'discount_percent')} }/>
      <div className="mt-2">
        { percent_shortcuts.map((value) => (
          <button
            key={"discount_shortcut_" + value}
            type="button"
            className="btn btn-outline-secondary btn-sm me-1"
            onClick={() => onChangeInput(value, 'discount_percent')}
          >
            {value}%
          </button>
        )) }
      </div>
      <small className="text-muted d-block mt-2">
        ≈ {text_amount(total * discount_percent / 100)}
      </small>
    </FormGroup>
  );
}

const render_rows = (tog_standard, modal_standard, onChangeInput, discount, discount_mode, discount_percent, total) => {

  return (
    <Modal
      isOpen={modal_standard}
      toggle={() => tog_standard('discount')}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myModalLabel">
          Descuento
        </h5>
        <button type="button"
                onClick={() => tog_standard('discount')}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <div className="btn-group mb-3" role="group">
          <button
            type="button"
            className={`btn btn-sm ${discount_mode === 'percent' ? 'btn-outline-secondary' : 'btn-secondary'}`}
            onClick={() => onChangeInput('amount', 'discount_mode')}
          >
            Monto
          </button>
          <button
            type="button"
            className={`btn btn-sm ${discount_mode === 'percent' ? 'btn-secondary' : 'btn-outline-secondary'}`}
            onClick={() => onChangeInput('percent', 'discount_mode')}
          >
            %
          </button>
        </div>
        <Form>
          <Row>
            <Col sm="12">
              { discount_mode === 'percent'
                ? render_percent_tab(onChangeInput, discount_percent, total)
                : render_amount_tab(onChangeInput, discount)
              }
            </Col>
          </Row>
        </Form>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={() => onChangeInput(0, 'discount_close')}
          className="btn btn-secondary waves-effect"
          data-dismiss="modal"
        >
          Cancelar
        </button>
        <button
          type="button"
          className="btn btn-primary waves-effect waves-light"
          style={{ backgroundColor: 'rgb(174,174,174)', borderColor: 'rgb(177,177,177)' }}
          onClick={() => tog_standard('discount')}
        >
          Aceptar
        </button>
      </div>
    </Modal>
  );
}

const ModalDiscount = ({tog_standard, modal_standard, onChangeInput, discount, discount_mode, discount_percent, total}) => (
  render_rows(tog_standard, modal_standard, onChangeInput, discount, discount_mode, discount_percent, total)
)

export default ModalDiscount
